<template>
  <div class="row">
    <div class="small-12 cell">
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareDivider',
};
</script>

<style scoped>

 hr {
   color: #b4bfc8;
   margin: 0;
 }

</style>
